import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {StockCheckM} from "../model/stock_check.model";
import {StockCheckDetailM} from "../model/stock_check_detail.model";
import {Util} from "../util/util";

@Injectable()
export class StockCheckService {

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(type: string, detail_type: string, searchStr: string, status: string, status_payment: string, seller_id: number = 0, shipping_id: number = 0, sales_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/stock/check/list?type=${type}&detail_type=${detail_type}&searchStr=${searchStr}&check_result=${status}&status_payment=${status_payment}&seller_id=${seller_id}&shipping_id=${shipping_id}&sales_id=${sales_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }


  getDetail(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/stock/check/detail/${bill_no}`, this.options).map(res => res.json());
  }

  getDetailById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/stock/check/detail/${id}`, this.options).map(res => res.json());
  }


  create(item: StockCheckM) {
    this.reloadToken()
    return this.http.post(`/api/stock/check`, item, this.options).map(res => res.json());
  }

  createDetail(item: StockCheckDetailM) {
    this.reloadToken()
    return this.http.post(`/api/stock/check/detail`, item, this.options).map(res => res.json());
  }

  update(item: StockCheckM) {
    this.reloadToken()
    return this.http.put(`/api/stock/check/detail/${item.id}`, item, this.options).map(res => res.json());
  }

  delete(id: number) {
    this.reloadToken()
    return this.http.delete(`/api/stock/check/detail/${id}`, this.options).map(res => res.json());
  }

  deleteStockCheck(id: number) {
    this.reloadToken()
    return this.http.delete(`/api/stock/check/deleteMain/${id}`, this.options).map(res => res.json());
  }

  updateStatus(id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/stock/check/status/${id}/${status}`, {}, this.options).map(res => res.json());
  }

  getStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/stock/check/getStatusCount`, this.options).map(res => res.json());
  }

  analyze(id: number) {
    this.reloadToken()
    return this.http.get(`/api/stock/check/analyze/${id}`, this.options).map(res => res.json());
  }

  getStockCheckResult(id: number,status='') {
    this.reloadToken()
    return this.http.post(`/api/stock/check/result/${id}`,{status:status}, this.options).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/stock-check.service.ts